import React, { useContext, useState, useCallback, useMemo, memo } from 'react';
import '../MisceleniousStyles.css'
import './TasksTagDisplay.css'
import BtnAdd from "../../buttons/btnAdd.component/BtnAdd";
import TagSelector from "../TagSelector/TagSelector";
import { Context } from "../../../index";
import ExitCross from "../../../assets/cancelGreey.svg"
import { AppContext } from "../../../App";
import axios from 'axios';
import TaskTag from '../TaskTag';
import { ITag } from '../../../common/api_interfaces/tag/ITag';

const tagsFolded: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    overflowX: "hidden"
}

const tagsUnfolded: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    flexWrap: "wrap"
}

const buttonUnfolded: React.CSSProperties = {
    backgroundColor: "lightgray",
    color: "#fff",
    padding: "3px"
}
interface ITasksTagDisplayProps {
    tags: ITag[];
    projectId: number;
    taskId: number | undefined;
    addTagsFunc: (tags: ITag[]) => Promise<void>;
    removeTags: (tag: ITag | ITag[]) => Promise<void>;
    permission?: boolean;
}

const TasksTagDisplay: React.FC<ITasksTagDisplayProps> = memo(({
    tags,
    projectId,
    taskId,
    addTagsFunc,
    removeTags,
    permission
}) => {
    const { store } = useContext(Context);
    const [showTagPopup, setShowTagPopup] = useState(false);
    const [showAllTags, setShowAllTags] = useState(false);

    const { showToast } = useContext(AppContext);

    const onClosePopup = useCallback(() => {
        setShowTagPopup(false);
    }, []);

    const onAddButton = useCallback(async () => {
        if (!permission) {
            showToast("У вас нет прав для редактирования задачи!");
            return;
        }

        try {
            await store.taskService.getTegs({
                taskId: 1,
                projectId: 1,
                userId: 0,
            });
            setShowTagPopup(true);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                showToast(error.response?.data?.message);
            }
        }
    }, [permission, store.taskService, showToast]);

    const onAddTagsAccept = useCallback(async (_tags: ITag[]) => {
        await addTagsFunc(_tags);
    }, [addTagsFunc]);

    const handleRemoveTags = useCallback(async (_tags: ITag | ITag[]) => {
        if (!permission) {
            showToast("У вас нет прав для редактирования задачи!");
            return;
        }

        await removeTags(_tags);
    }, [permission, removeTags, showToast]);

    const changeTagsFold = useCallback(() => {
        setShowAllTags(prev => !prev);
    }, []);

    const displayedTags = useMemo(() =>
        showAllTags ? tags : tags.slice(0, 3),
        [tags, showAllTags]
    );

    const hiddenTagsCount = useMemo(() =>
        tags.length > 3 ? tags.length - 3 : 0,
        [tags.length]
    );

    return (
        <div style={{ position: "relative" }}>
            <div
                style={showAllTags ? tagsUnfolded : tagsFolded}
                className='tag-add-popup-tegs__block'
            >
                <div className='tag-add-popup-button--block'>
                    <BtnAdd
                        type="tag-add-popup-button"
                        onClickFunc={onAddButton}
                        permission={permission}
                    />
                </div>

                <div className='tegs_popup-items'>
                    {displayedTags.map((item) => (
                        <TaskTag key={item.id} color={item.color} name={item.name} />
                    ))}

                    {!showAllTags && hiddenTagsCount > 0 && (
                        <div
                            className='tag-add-popup__show--all'
                            onClick={changeTagsFold}
                        >
                            {`+${hiddenTagsCount}`}
                        </div>
                    )}

                    {showAllTags && (
                        <div
                            className='tag-add-popup__hide__all'
                            onClick={changeTagsFold}
                            style={buttonUnfolded}
                        >
                            <img src={ExitCross} alt="Hide tags" />
                        </div>
                    )}
                </div>
            </div>

            {showTagPopup && (
                <>
                    <div
                        className='full-screen-overlay'
                        style={{ opacity: "0.8" }}
                        onClick={onClosePopup}
                    />
                    <div className='task__teg--display__popup--add__teg'>
                        <div className='task__teg--display__popup--add__teg--header'>
                            <div className='task__teg--display__popup--add__teg--name'>
                                Добавление тегов
                            </div>
                            <div
                                className='task__teg--display__popup--add__teg--cross'
                                onClick={onClosePopup}
                            >
                                <img src={ExitCross} alt="Close" />
                            </div>
                        </div>
                        <div className='task__teg--display__popup--add__teg--name__TagSelector'>
                            <TagSelector
                                tags={tags}
                                projectId={projectId}
                                taskId={taskId}
                                addTagsFunc={onAddTagsAccept}
                                removeTagsFunc={handleRemoveTags}
                                closeFunc={onClosePopup}
                            />
                        </div>
                        <div className='tegs__color--popup__button--add__save--block'>
                            <div
                                className='tegs__color--popup__button--add__teg'
                                onClick={onClosePopup}
                            >
                                Сохранить
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
});

TasksTagDisplay.displayName = 'TasksTagDisplay';

export default TasksTagDisplay;